import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { GET_SUMMARY_SUCCEED_DASHBOARD, resetWsStats, showModalImportDashboard } from 'Screens/Contextualization/Dashboard/actions/Actions';
import { FormattedMessage } from 'react-intl';
import ModalCreation from 'Screens/Contextualization/Workspaces/components/ModalCreation';
import { PropTypes } from 'prop-types';
import { getVulnsCountInWs, saveWorkspaceHistory } from 'Screens/Contextualization/Faraday/actions/Actions';
import selectModal from 'store/modals/selectors';
import { closeModal, openModal } from 'store/modals/actions';
import { selectAllVulnsCount, selectCurrentWorkspace, selectIsAdmin, selectReadOnly, selectInitialAmountOfVulns, selectFaradayLoading } from 'store/Faraday/selectors';
import useClickOutside from 'Hooks/useClickOutside';
import replace from 'lodash/replace';
import get from 'lodash/get';
import { MODAL_WORKSPACE_CREATE } from 'store/modals/modals';
import { redirect } from 'store/Router/actions';
import { selectLocation } from 'store/Router/selectors';
import { getWorkspacesForSelector, setWsStatsError } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { clearFilters, setPageNumber, resetFilters } from 'store/Filters/actions';
import { newGetVulns } from 'store/Manage/filterActions';
import {
  Wrapper, Toggle, Menu, Item, WorkspaceSelectedName,
  ArrowDown, WorkspaceOptionName, ActionsContainer,
  ViewAll, CreateNew, NoItems, WsIcon, WsWrapper,
  IconWrapper, LockIcon, WsSelected
} from './styled';
import { redirectToHost } from 'store/Contextualization/AssetDetail/actions';

import { selectWorkspacesForSelector } from 'store/Workspace/selectors';
import api from 'services/api';
import SpinnerComponent from 'Common/Components/SpinnerContainer';
import formatNumber from 'Common/Functions/FormatNumber';
import { getData } from 'store/Host/actions';
import { getServices } from 'store/Services/actions';
import { CloseIcon, CloseIconWrapper, Icons } from '../AssetSelector/styled';
import { getCredentials } from 'store/Credentials/actions';
import { getSelectedEntity } from 'store/Filters/selectors';
import Spinner from 'Common/Components/Spinner';
import { selectIsFetching } from 'store/ManageGeneral/selectors';
import { selectIsFetching as selectManageIsFetching } from 'store/Manage/selectors';
import { selectIsFetching as selectDashboardIsFetching } from 'store/Dashboard/selectors';

const WorkspaceSelector = ({
  saveWorkspaceHistoryProp, workspaces, workspaceSelected, isReadOnly
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dispatch = useDispatch();
  const noWorkspaces = workspaces.length === 0;
  const showNoItem = noWorkspaces || (workspaces.length === 1 && workspaces[0].name === workspaceSelected);
  const dropdownRef = useRef();
  useClickOutside(dropdownRef, () => setShowDropdown(false));
  const location = useSelector(selectLocation);
  const isAdmin = useSelector(selectIsAdmin);
  const isManage = get(location, 'pathname', '').includes('/manage');
  const isAssets = get(location, 'pathname', '').includes('/host') && !(get(location, 'pathname', '').includes('/vulns')) && !(get(location, 'pathname', '').includes('/services'));
  const isServices = get(location, 'pathname', '').includes('/service');
  const isVulnsAssets = get(location, 'pathname', '').includes('/host') && get(location, 'pathname', '').includes('/vulns');
  const isServicesAssets = get(location, 'pathname', '').includes('/host') && get(location, 'pathname', '').includes('/services');
  const isDashboard = get(location, 'pathname', '').includes(`/feed/${workspaceSelected}`);
  const isFetching = useSelector(selectFaradayLoading);
  const generalIsFetching = useSelector(selectIsFetching);
  const manageIsFetching = useSelector(selectManageIsFetching);
  const dashboardIsFetching = useSelector(selectDashboardIsFetching);
  const stats = useSelector((state) => get(state, 'dashboard.tools[3].data.stats', {}));
  const vulnsCountDashboard = get(stats, 'total_vulns', 0);
  const allVulnsCount = useSelector(selectAllVulnsCount);
  const vulnsCount = isDashboard ? vulnsCountDashboard : allVulnsCount;
  const insideAsset = isVulnsAssets || isServicesAssets;
  const isCredentials = get(location, 'pathname', '').startsWith('/credentials/');
  const entity = useSelector(getSelectedEntity);

  const snapshotRef = useRef(null);
  const otherIsFetching = generalIsFetching || manageIsFetching || dashboardIsFetching;
  const initialVulnsCount = useSelector(selectInitialAmountOfVulns);

  const safeInitialCount =
  initialVulnsCount?.ws === workspaceSelected
    ? initialVulnsCount?.count
    : null;

  const isCurrentWs = initialVulnsCount?.ws === workspaceSelected;
  const displayedCount = isCurrentWs && allVulnsCount === 0 ? safeInitialCount : vulnsCount;

  const shouldShowSpinner =
  (otherIsFetching && initialVulnsCount?.ws !== workspaceSelected) ||
  (
    !otherIsFetching &&
    initialVulnsCount?.ws !== workspaceSelected &&
    vulnsCount === 0
  );

  const vulnText = () => {
    const count = displayedCount ?? 0;
    if (isFetching && initialVulnsCount?.ws !== workspaceSelected) {
      return <Spinner size={ 30 } />;
    }
    if (insideAsset) {
      return `(${formatNumber(count)})`;
    }

    if (count === 1) {
      return `(${count} vulnerability)`;
    }

    return `(${count} vulnerabilities)`;
  };

  const redirectTo = (ws) => {
    let url = '';
    if (location.pathname === '/404') {
      url = `/feed/${ws.name}`;
    } else {
      url = replace(location.pathname, workspaceSelected, ws.name);
    }
    dispatch(redirect(`${url}`));
  };

  const selectWorkspace = async (ws) => {
    saveWorkspaceHistoryProp(ws.name);
    redirectTo(ws);
    if (!isDashboard) {
      try {
        const response = await api.workspace.getWsStats(ws.name);
        dispatch({ type: GET_SUMMARY_SUCCEED_DASHBOARD, data: response });
      } catch (error) {
        dispatch(setWsStatsError(error.message));
      }
    }
    if (ws.stats.total_vulns === 0) dispatch(showModalImportDashboard(true));
    if (isManage || isCredentials || isAssets || isServices) dispatch(setPageNumber(entity, 1));
    if (isManage) {
      dispatch(newGetVulns());
    }
    if (isAssets) {
      dispatch(getData());
      dispatch(getVulnsCountInWs());
    }
    if (isServices) {
      dispatch(getServices());
    }
    if (insideAsset) {
      dispatch(redirectToHost());
      dispatch(getVulnsCountInWs());
    }
    if (isCredentials) dispatch(getCredentials());
  };

  const getItems = () => {
    if (isFetching) return <SpinnerComponent height="70px" />;
    if (showNoItem) {
      return (
        <NoItems><FormattedMessage id="workspaces.contextMenu.no_other" /></NoItems>
      );
    }

    const onClickItem = (ws) => {
      selectWorkspace(ws);
      setShowDropdown(false);
      dispatch(clearFilters('vulns'));
      dispatch(clearFilters('assets'));
      dispatch(clearFilters('vulnsAssets'));
      dispatch(resetFilters('dashboard'));
    };

    return workspaces.map((ws, index) => {
      if (ws.name !== workspaceSelected) {
        return (
          <Item id={ `ws-selector-${ws.name}` } onClick={ () => onClickItem(ws) } key={ ws.name } lastelement={ index + 1 === workspaces.length }>
            <WorkspaceOptionName>{ws.name}</WorkspaceOptionName>
          </Item>
        );
      } return null;
    });
  };

  const show = useSelector((state) => selectModal(state, MODAL_WORKSPACE_CREATE));
  const handleClose = () => dispatch(closeModal(MODAL_WORKSPACE_CREATE));
  const handleOpen = () => dispatch(openModal(MODAL_WORKSPACE_CREATE));
  const handleToggle = () => {
    setShowDropdown(!showDropdown);
    if (!showDropdown) {
      dispatch(getWorkspacesForSelector());
    }
  };

  const viewAllHandleClick = () => {
    dispatch(clearFilters('vulns'));
    dispatch(clearFilters('assets'));
    dispatch(resetFilters('dashboard'));
    setShowDropdown(false);
    dispatch(redirect('/workspaces'));
  };

  const goToOutsideWs = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(redirect('/workspaces'));
    setShowDropdown(false);
  };

  useEffect(() => () => {
    dispatch(resetWsStats());
  }, [dispatch]);

  const initialVulnsCountWs = initialVulnsCount?.ws;
  const initialVulnsCountCount = initialVulnsCount?.count;

  useEffect(() => {
    if (initialVulnsCountWs === workspaceSelected) {
      snapshotRef.current = initialVulnsCountCount;
    }
  }, [initialVulnsCountWs, initialVulnsCountCount, workspaceSelected]);

  return (
    <Wrapper ref={ dropdownRef } data-tour="Workspace Selector" insideAsset={ insideAsset }>
      <Toggle onClick={ handleToggle }>
        <IconWrapper><WsIcon /></IconWrapper>
        <WsWrapper insideAsset={ insideAsset }>
          <WsSelected>
            { isReadOnly && <LockIcon />}
            <WorkspaceSelectedName id={ `ws-selector-selected-${workspaceSelected}` } title={ workspaceSelected || 'No Workspace Selected' } insideAsset={ insideAsset } lockedWs={ isReadOnly }>
              {workspaceSelected}
              {' '}
              {
                shouldShowSpinner
                  ? <Spinner size={ 30 } />
                  : vulnText()
              }
            </WorkspaceSelectedName>
          </WsSelected>
          <Icons>
            <CloseIconWrapper onClick={ goToOutsideWs }>
              <CloseIcon />
            </CloseIconWrapper>
            <ArrowDown />
          </Icons>
        </WsWrapper>
      </Toggle>
      { workspaces.length >= 0 && showDropdown && (
        <Menu>
          {getItems()}
          <ActionsContainer>
            {!noWorkspaces && <ViewAll onClick={ viewAllHandleClick }><FormattedMessage id="workspaces.contextMenu.viewAll" /></ViewAll>}
            { isAdmin && <CreateNew onClick={ () => { setShowDropdown(false); handleOpen(); } }><FormattedMessage id="workspaces.contextMenu.createNew" /></CreateNew> }
          </ActionsContainer>
        </Menu>
      ) }
      {show && <ModalCreation show handleClose={ handleClose } /> }
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  workspaces: selectWorkspacesForSelector(state),
  workspaceSelected: selectCurrentWorkspace(state),
  isReadOnly: selectReadOnly(state)
});

const mapDispatchToProps = (dispatch) => ({
  saveWorkspaceHistoryProp: (ws) => {
    dispatch(saveWorkspaceHistory(ws));
  }
});

WorkspaceSelector.propTypes = {
  workspaces: PropTypes.instanceOf(Object).isRequired,
  workspaceSelected: PropTypes.string.isRequired,
  saveWorkspaceHistoryProp: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkspaceSelector));
